import { render } from "./gift-guide-right-collection.vue?vue&type=template&id=ca1641f6&scoped=true"
import script from "./gift-guide-right-collection.vue?vue&type=script&lang=js"
export * from "./gift-guide-right-collection.vue?vue&type=script&lang=js"

import "./gift-guide-right-collection.vue?vue&type=style&index=0&id=ca1641f6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1641f6"]])

export default __exports__